import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const itemTypesListSlice = createSlice({
  name: "itemTypesListSlice",
  initialState,
  //REDUCER
  reducers: {
    setItemTypesList(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    addTypes(state, action) {
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    },
    editTypes(state, action) {
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    },
    deleteTypes(state, action) {
      return {
        ...state,
        rows: state.rows.filter((row) => row.id !== action.payload),
      };
    },
  },
});

//ACTIONS
export const {
    setItemTypesList,
    showLoading,
    hideLoading,
    addTypes,
    editTypes,
    deleteTypes,
} = itemTypesListSlice.actions;

export default itemTypesListSlice.reducer;
